import { engineeringEnvironment } from './engineering';
import { legalEnvironment } from './legal';
import type { EnvironmentDescriptor, EnvironmentId } from './types';

export type { EnvironmentDescriptor, EnvironmentId } from './types';

export const environments: Readonly<Record<EnvironmentId, EnvironmentDescriptor>> = {
  engineering: engineeringEnvironment,
  legal: legalEnvironment,
};

export const environmentList: readonly EnvironmentDescriptor[] = Object.freeze([
  legalEnvironment,
  engineeringEnvironment,
]);
